import React, { FC } from "react";

import infoCircle from "../../assets/infoCircle.svg";
import "./Fees.scss";

const Fees: FC<{
  feesTitle: string;
  feesDescription?: string;
  alert?: boolean;
  buySell?: boolean;
}> = ({ feesDescription, feesTitle, alert, buySell }) => {
  return (
    <div className={`fees ${alert && "fees--alert"}`}>
      <img src={infoCircle} alt="info" />
      <div className="fees__info">
        <p className="fees__title">{feesTitle}</p>
        {feesDescription && (
          <p className="fees__description">
            {!buySell && <span>&#8776; </span>}
            {feesDescription}
          </p>
        )}
      </div>
    </div>
  );
};

export default Fees;
